import { useState } from "react";
import { Popover, PopoverTrigger, PopoverContent } from "components/ui/popover";
import { Button } from "components/ui/button";
import { X, Check } from "lucide-react";
import clsx from "clsx";

const sortOptions = ["Latest Ads", "New Ads", "Most Hit Ads", "Price: Low to High", "Price: High to Low"];

export default function SortPopover() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedSort, setSelectedSort] = useState<string | null>(null);

  const handleSelect = (option: string) => {
    setSelectedSort(option);
    setIsOpen(false);
  };

  const handleClear = (e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedSort(null);
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="flex items-center gap-2">
          📊 {selectedSort ?? "Sort"}
          {selectedSort && <X size={14} className="text-muted-foreground hover:text-destructive" onClick={handleClear} />}
        </Button>
      </PopoverTrigger>

      <PopoverContent className="w-64 p-0">
        {sortOptions.map((option) => (
          <div
            key={option}
            onClick={() => handleSelect(option)}
            className={clsx("px-4 py-2 cursor-pointer hover:bg-muted flex justify-between items-center", selectedSort === option && "font-medium")}
          >
            {option}
            {selectedSort === option && <Check className="w-4 h-4 text-blue-600" />}
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
}

